import moment from 'moment';

var config = require('../../config.js');
const reservebackend = config.reservebackend;
const year_s = config.start_year;


export const getStaffList = _ => {

  return new Promise(function(resolve, reject) {

    // Get all the staffs
    fetch_retry(reservebackend + `api/allstaffsimple`, {}, 3)
    .then(res => res.json())
    .then(({data}) => {
      var staffs = {};
      var i = 0
      for (i = 0; i < data.length; i++) {
          staffs[data[i]['value']] = data[i]['label']
      }
      if (i === data.length){
        resolve (staffs);
      }

    });

  });

}


export const getMonthList = _ => {

  return new Promise(function(resolve, reject) {

    const months = moment.months();
    var months_drop = [];
    for (var m in months){
      months_drop.push({
        'value': m,
        'label':months[m]
      });
    }
    resolve(months_drop);

  });

}


export const getYearList = _ => {

  return new Promise(function(resolve, reject) {

    var year = year_s;
    var year_e = moment().year();

    // If is it the last month of the year and date is more than 15th
    if (moment().month() === 11 && moment().date() >= 15){
      year_e =  moment().year() + 1;
    }

    let years_drop = [];

    while (year < year_e+1){
      years_drop.push({
        'value': year,
        'label':year
      })
      year = year + 1;
    }

    years_drop.sort((a, b) =>
      a.value < b.value ? 1 : ((b.value < a.value) ? -1 : 0)
    );

    resolve(years_drop);

  });

}

export const getFinYearList = _ => {

  return new Promise(function(resolve, reject) {

    // start of Financial Year is on the month of September
    const months = moment.months();
    var year_l = moment().year() - 1;
    var year_c = moment().year();
    let monthyear_drop = [];

    // Sep 20 to Dec 21
    while (year_l < year_c+1) {
      for (var i = 8; i < 12; i++)
      {
        monthyear_drop.push({
          'value': [i, year_l],
          'label': months[i] + ' ' + year_l
        })
      }
      year_l++;
      for (var v = 0; v < 12; v++)
      {
        monthyear_drop.push({
          'value': [v, year_l],
          'label': months[v] + ' ' + year_l
        })
      }
      year_l++;
    }

    resolve(monthyear_drop);

  });

}


export const fetch_retry = async (url, options, n) => {
    try {
        return await fetch(url, options);
    } catch(err) {
        console.log('Retry left', n-1, 'url', url)
        if (n === 1) throw err;
        return await fetch_retry(url, options, n - 1);
    }
};


export const customStyles = {
    control: (base, state) => ({
      ...base,
      height: '45px',
      'min-height': '45px',
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state.selectProps.menuIsOpen ? '#C0C0C0' : base.color,
    })
};


export const desigsStyles = {
  control: (base, state) => ({
    ...base,
    height: '30px',
    'min-height': '30px',
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.selectProps.menuIsOpen ? '#C0C0C0' : base.color,
  })
};
